var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7895 17.1847V12.9889C11.7833 12.4505 11.6966 12.2237 11.2 12.1025H3.08C2.52076 12.194 2.33274 12.3717 2.24 12.9889V17.1847C0.652305 17.0517 0.0878827 17.5535 0 16.4118V10.5882C0 9.71471 0.994737 9 2.21053 9H11.7895C13.0053 9 14 9.71471 14 10.5882V16.4118C14 17.2853 13.0053 17.1847 11.7895 17.1847Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8C8.98528 8 11 6.20914 11 4C11 1.79086 8.98528 0 6.5 0C4.01472 0 2 1.79086 2 4C2 6.20914 4.01472 8 6.5 8Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.9287b1a995477740ddd5d5a22aa45711.svg";
export { ForwardRef as ReactComponent };